import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';
import FilterActions from '../FilterActions/FilterActions';
import FiltersRow from '../FiltersRow/FiltersRow';
import DateFilter from '../filters/DateFilter/DateFilter';
import useRequestsQueryState from '../../hooks/useRequestsQueryState';
import { useSelector } from 'react-redux';
import { filtersData } from '../../constants/filtersData';
import { filterNames } from '../../constants/filterNames';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import useResetFilter from '../../hooks/useResetFilter';
import { isDefaultFilter } from '../../helpers/isDefaultFilter';
import styles from './FiltersBlock.module.scss';
import { Icon } from 'antd';
import { BuildReportDropdown } from '../BuildReportDropdown/BuildReportDropdown';
import { useSaveDefaultFilter } from '../../mutations/useSaveDefaultFilterMutation';
import { savedFiltersKey } from '../../queries/useSavedFilters';
import { queryClient } from '../../../../queryClient';

const FiltersBlock = ({
  handleActionsMenuClick,
  isReport,
  showInLifeCirle,
}) => {
  const requestsQueryState = useRequestsQueryState();
  const isCounting = useSelector((state) => state.statisticsStore.isCounting);

  const [defaultFilter, setDefaultFilter] = useState(null);

  const history = useHistory();

  const resetFilter = useResetFilter();

  const { mutate: unsaveDefaultFilter } = useSaveDefaultFilter({
    onSuccess: () => queryClient.invalidateQueries(savedFiltersKey())
  });

  const handleResetFilter = () => {
    resetFilter();
    unsaveDefaultFilter({
      id: defaultFilter?.id,
      value: false,
      type: 'unsave',
    });
    setDefaultFilter(null)
  };

  const resetBtnDisabled = isDefaultFilter(history.location.search);

  const [active, setActive] = useState(true);

  const handleActive = () => {
    setActive((prev) => !prev);
  };

  return (
    <div className={cn(styles.root)}>
      <div className={styles.container}>
        <div className={styles.dateFilterWrap}>
          <DateFilter
            className={styles.dateFilter}
            disabled={requestsQueryState?.isFetching || isCounting}
            filterText="Период"
            allowRemove={false}
            filterData={filtersData[filterNames.createDate]}
            containerKey={filterNames.createDate}
          />
          <DateFilter
            className={styles.dateFilter}
            disabled={requestsQueryState?.isFetching || isCounting}
            containerKey={filterNames.doneDate}
            filterText="Дата назначения"
            filterData={filtersData[filterNames.doneDate]}
          />
        </div>

        <div className={styles.filterActions}>
          <FilterActions
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
          <RoundedButton
            className={styles.resetFiltersBtn}
            disabled={
              requestsQueryState?.isFetching || isCounting || resetBtnDisabled
            }
            type="primary-orange"
            text="Сбросить фильтр"
            onClick={handleResetFilter}
          />
        </div>
        <div className={cn(styles.rightItems, styles.rightContainer)}>
          {typeof handleActionsMenuClick === 'function' && (
            <div className={styles.buildReport}>
              <BuildReportDropdown
                disabled={false}
                onMenuClick={handleActionsMenuClick}
              />
            </div>
          )}

          <RoundedButton
            className={styles.showMore}
            onClick={handleActive}
            text={<Icon type={active ? 'caret-up' : 'caret-down'} />}
          />
        </div>
      </div>

      {/* </div> */}
      {active && <FiltersRow showInLifeCirle={showInLifeCirle} />}
    </div>
  );
};

export default FiltersBlock;
